<mat-label>{{header}}</mat-label>
<select multiple (change)="setDatas($event)">
    <option [value]=null>Seleccione una opción...</option>
    <option *ngFor="let item of array" [value]="item.id">{{item.nombre}}</option>
</select>
<mat-error>{{error}}</mat-error>
